// extracted by mini-css-extract-plugin
export default {"container":"I7-z","leftColumn":"J7-z","rightColumn":"K7-z","item":"L7-z"};